import { useEffect } from 'react';
import './blogs/blog.css';
const Tnc = () => {
  const tncStyle = { display: 'flex' };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={tncStyle}>
      <div className="left" style={{ flex: 2 }}></div>
      <div className="blog" style={{ flex: 6 }}>
        <div className="blog-title">Terms and Conditions</div>

        <div className="blog-content">
          <p>
            Thank you for taking the time to visit Quantum World. We aim to
            spread as much knowledge about Quantum Computing as we can.
          </p>
          <p>
            These terms and conditions ("Agreement") govern your use of the
            quantumcomputing.com website ("Website" or "Service"), as well as
            any of its connected products and services (collectively,
            "Services"). This Agreement legally binds you ("User," "you," or
            "your") and this Website operator ("Operator", "we", "us" or "our").
            You acknowledge that you have read, understood, and agree to be
            bound by the terms of this Agreement by accessing and using the
            Website and Services. If you are engaging into this Agreement on
            behalf of a company or other legal entity, you represent that you
            have the capacity to bind that entity to this Agreement; in such
            instance, the terms "User," "you," or "your" refer to that entity.If
            you do not have such authority, or if you do not agree with the
            terms of this Agreement, you must not accept this Agreement and may
            not access and use the Website and Services. You acknowledge that,
            despite the fact that it is electronic and not physically signed by
            you, this Agreement constitutes a contract between you and the
            Operator that governs your use of the Website and Services. This
            terms and conditions policy was created with the help of the terms
            and conditions generator.
          </p>
          <div className="blog-heading">Accounts and membership</div>
          <p>
            If you create an account on the Website, you are responsible for
            keeping your account secure and for any activities that occur under
            your account as well as any other actions done in connection with
            it. We may monitor and review new accounts before allowing you to
            sign in and use the Services, but we are under no duty to do so.
            Your account may be terminated if you provide fraudulent contact
            information of any type. Any unauthorised use of your account or
            other security breaches must be reported immediately to us. We are
            not responsible for your actions or omissions, including any damages
            suffered as a result of such actions or omissions.If we conclude
            that you have violated any provision of this Agreement or that your
            conduct or content would tend to harm our reputation and goodwill,
            we may suspend, disable, or delete your account (or any portion of
            it). You will not be able to re-register for our Services if we
            remove your account for the reasons stated above. To prevent further
            registration, we may block your email address and IP address.
          </p>
          <div className="blog-heading">User content</div>
          <p>
            Any data, information, or material (collectively, "Content") that
            you provide on the Website while using the Service is not our
            property. You are solely responsible for all submitted Content's
            accuracy, quality, integrity, legality, reliability,
            appropriateness, and intellectual property ownership or right to
            use. We reserve the right to monitor and review any content posted
            to the WebsiteYou authorise us to access, copy, distribute, store,
            transmit, reformat, display, and perform the Content of your user
            account exclusively for the purpose of providing you with the
            Services. We reserve the right, but not the obligation, to refuse to
            remove any Content that violates any of those representations or
            warranties, at our sole discretion., in our opinion, violates any of
            our policies or is harmful or objectionable in any manner. You also
            give us permission to use, reproduce, adapt, modify, publish, or
            distribute the Content you generate or save in your user account for
            commercial, marketing, or other purposes.
          </p>
          <div className="blog-heading">Backups</div>
          <p>
            We backup the Website and its Content on a regular basis, however
            these backups are primarily for our own administrative purposes and
            are not guaranteed. You are responsible for keeping backups of your
            data on your own.In the case that backups fail, we do not offer any
            kind of compensation for data that is lost or incomplete. We will
            try our best to ensure comprehensive and accurate backups, but we
            will not be held liable.
          </p>
          <div className="blog-heading">Links to other resources</div>
          <p>
            Although the Website and Services may contain links to other
            resources (such as websites and mobile applications), we do not
            imply any approval, association, sponsorship, endorsement, or
            relationship with any connected resource, unless otherwise
            specified.Some of the Website's connections may be "affiliate
            links." This implies that if you click on the link and buy
            something, the Operator will get a commission. We are not
            responsible for researching or evaluating any businesses or
            individuals' offers, nor do we guarantee the content of their
            materials. We do not accept any responsibility or liability for any
            third-party acts, products, services, or material. You should read
            the legal notices and other terms and conditions of every resource
            you access through a link on the Website and Services carefully.Your
            linking to any other off-site resources is at your own risk.
          </p>
          <div className="blog-heading">Prohibited uses</div>
          <p>
            You are not permitted to use the Website, Services, or Content for
            any of the following purposes: (a) for any unlawful purpose; (b) to
            solicit others to perform or participate in any unlawful acts; (c)
            to violate any international, federal, provincial, or state
            regulations, rules, laws, or local ordinances; (d) to infringe upon
            or violate our intellectual property rights.; (e) to harass, abuse,
            insult, harm, defame, slander, disparage, intimidate, or
            discriminate on the basis of gender, sexual orientation, religion,
            ethnicity, race, age, national origin, or disability; (f) to submit
            false or misleading information; (g) to upload or transmit viruses
            or any other type of malicious code that will or may affect the
            functionality or operation of the Website and Services, third party
            products and services, or the Internet;(g) to spam, phish, pharm,
            pretext, spider, crawl, or scrape; I for any obscene or immoral
            purpose; or (j) to tamper with or circumvent the Website's and
            Services' security features, third-party products and services, or
            the Internet's security features. If you violate any of the
            prohibited uses, we have the right to discontinue your usage of the
            Website and Services.
          </p>
          <div className="blog-heading">Intellectual property rights</div>
          <p>
            All present and future rights conferred by statute, common law, or
            equity in or in relation to any copyright and related rights,
            trademarks, designs, patents, inventions, goodwill and the right to
            sue for passing off, rights to inventions, rights to use, and all
            other intellectual property rights are referred to as "intellectual
            property rights”,in each case, whether registered or unregistered,
            and including all applications and rights to apply for and be
            granted, rights to claim priority from, and all similar or
            equivalent rights or forms of protection, as well as any other
            results of intellectual activity that exist or will exist now or in
            the future in any part of the world.This Agreement does not transfer
            any intellectual property owned by the Operator or third parties to
            you, and the Operator retains all rights, titles, and interests in
            and to such property (as between the parties). All trademarks,
            service marks, images, and logos used in conjunction with the
            Website and Services are the Operator's or its licensors' trademarks
            or registered trademarks. Other trademarks, service marks, images,
            and logos used in conjunction with the Website and Services could be
            third-party trademarks. You have no right or licence to duplicate or
            otherwise use any of the Operator's or third-party trademarks as a
            result of your use of the Website and Services.
          </p>
          <div className="blog-heading">Severability</div>
          <p>
            All rights and limits in this Agreement may be exercised and are
            only applicable and binding to the extent that they do not violate
            any relevant laws and are intended to be limited to the extent
            necessary to keep this Agreement legal, valid, and enforceable. If
            any provision or portion of any provision of this Agreement is held
            by a court of competent jurisdiction to be illegal, invalid, or
            unenforceable, the parties intend that the remaining provisions or
            portions thereof shall constitute their agreement with respect to
            the subject matter hereof, and all such remaining provisions or
            portions thereof shall constitute their agreement with respect to
            the subject matter thereof shall remain in full force and effect.
          </p>
          <div className="blog-heading">Changes and amendments</div>
          <p>
            We retain the right to change this Agreement or its provisions
            relating to the Website and Services at any time, with an updated
            version of this Agreement becoming effective upon publication on the
            Website. We'll update the new date at the bottom of this page once
            we've done so. Your continued use of the Website and Services
            following any such modifications constitutes your acceptance of
            those changes.
          </p>
          <div className="blog-heading">Acceptance of these terms</div>
          <p>
            You indicate that you have read and agree to all of the terms and
            conditions of this Agreement. You agree to be governed by this
            Agreement by accessing and using the Website and Services. You are
            not authorised to access or use the Website or Services if you do
            not agree to adhere by the terms of this Agreement.
          </p>
          <div className="blog-heading">Contacting us</div>
          <p>
            You may use the contact email to contact us if you have any
            questions regarding this Agreement or if you need to contact us
            about anything related to it.
          </p>
          <p>
            Contact email -{' '}
            <strong>
              <emphasis>contactus@quantumworld.com</emphasis>
            </strong>
          </p>
          <p>This document was last updated on June 25, 2021</p>
        </div>
      </div>
      <div className="right" style={{ flex: 2 }}></div>
    </div>
  );
};

export default Tnc;
